var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSidebarOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.5C2 3.70312 2.65625 3 3.5 3H21.5C22.2969 3 23 3.70312 23 4.5C23 5.34375 22.2969 6 21.5 6H3.5C2.65625 6 2 5.34375 2 4.5ZM2 12C2 11.2031 2.65625 10.5 3.5 10.5H21.5C22.2969 10.5 23 11.2031 23 12C23 12.8438 22.2969 13.5 21.5 13.5H3.5C2.65625 13.5 2 12.8438 2 12ZM21.5 21H3.5C2.65625 21 2 20.3438 2 19.5C2 18.7031 2.65625 18 3.5 18H21.5C22.2969 18 23 18.7031 23 19.5C23 20.3438 22.2969 21 21.5 21Z",
    fill: "#086DAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSidebarOff);
export default __webpack_public_path__ + "static/media/arrowSidebarOff.2b3e2c601e015a8f300f7380e9683c85.svg";
export { ForwardRef as ReactComponent };